export const languages = ["nl","fr","nd","de","en","es","fra","it","at","pl","pt","sv","fi","us"];